import { createApiAction } from '@app/packages/api/utils'
import type { ApiCurrency, ApiCurrencyRate } from '@app/packages/api/v2/types/entities'
import { v2Path } from '@app/packages/api/v2/utils'

export const getCurrencies = () =>
  createApiAction('getCurrencies', dispatch => dispatch<{ data: ApiCurrency[] }>({ method: 'GET', endpoint: '/api/v2/currencies' }))

export const getCurrencyRates = (base: string) =>
  createApiAction('getCurrencyRates', dispatch =>
    dispatch<{ data: ApiCurrencyRate[] }>({ method: 'GET', endpoint: v2Path('/api/v2/currencies/rates', { base }) })
  )
